import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      display: 'inline',
    },
    btn: {
      border: 0,
      borderRadius: '50%',
      backgroundColor: 'var(--x-bg-1)',
      height: 40,
      width: 40,
      cursor: 'pointer',
    },
    spaced: {
      marginInlineEnd: 9,
    },
    disabled: {
      cursor: 'default',

      '& path': {
        fill: '#c9c9c9',
      },
    },
  },
  { name: 'HistoryButtons' },
);
